import React, { useState, useEffect } from 'react';
import { s as styled, a as styled$1 } from './styled-112a8bd0.js';
import { S as SvgIcon } from './SvgIcon-1ee3e5bb.js';

const STEP = 100;
const StyledToast$2 = styled.div(({ showAnimation, startAnimation, animationConfig }) => `
    @keyframes slideOut {
      0% {
        transform: translateX(150%);
      }
      80% {
        transform: translateX(-20%);
      }
      100% {
        transform: translateX(0);
      }
    }
    @keyframes slideIn {
      0% {
        transform: translateX(0%);
      }
      20% {
        transform: translateX(-20%);
      }
      100% {
        transform: translateX(150%);
      }
    }
    @keyframes fadeOut {
      0% {
        opacity: 0;
        visibility: hidden;
        transform: scale(0);
      }
      100% {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }
    }
    @keyframes fadeIn {
      0% {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }
      100% {
        opacity: 0;
        visibility: hidden;
        transform: scale(0);
      }
    }
    max-height: ${showAnimation ? '200px' : 0};
    position: relative;
    width: max-content;
    animation-duration: ${animationConfig.duration / 1000}s;
    animation-name: ${startAnimation
    ? showAnimation
        ? `${animationConfig.name}Out`
        : `${animationConfig.name}In`
    : ''};
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    opacity: ${showAnimation ? 1 : 0};
    transition: all ${animationConfig.duration / 1000}s ease-out;
  `);
const ANIMATIONS = {
    slide: {
        name: 'slide',
        duration: 400,
    },
    fade: {
        name: 'fade',
        duration: 200,
    },
};
const ToastMessage = ({ children, onRemove, countdown = 3000, animation = 'slide', }) => {
    const [timer, setTimer] = useState(countdown);
    useEffect(() => {
        const it = setInterval(() => {
            setTimer((prev) => (prev - STEP > 0 ? prev - STEP : 0));
        }, STEP);
        return () => clearInterval(it);
    }, []);
    useEffect(() => {
        if (!timer) {
            setTimeout(() => {
                onRemove();
            }, ANIMATIONS[animation].duration);
        }
    }, [onRemove, timer]);
    return (React.createElement(StyledToast$2, { showAnimation: timer < countdown - STEP && timer > 0, startAnimation: timer < countdown - STEP, animationConfig: ANIMATIONS[animation] }, children));
};

const StyledToastContainer = styled.div `
  position: fixed;
  z-index: 100000;
  width: max-content;
`;
const TopLeft = styled(StyledToastContainer) `
  right: 1vw;
  top: 13vh;

  > :not(:last-child) {
    margin-bottom: 0.8rem;
  }
`;
const BottomCenter = styled(StyledToastContainer) `
  left: 50vw;
  transform: translateX(-50%);
  bottom: 12vh;
  display: flex;
  flex-direction: column-reverse;

  > :not(:last-child) {
    margin-top: 0.4rem;
  }
`;
const CenterCenter = styled(StyledToastContainer) `
  left: 50vw;
  top: 50vh;
  transform: translate(-50%, -50%);

  > :not(:last-child) {
    margin-bottom: 0.8rem;
  }
`;
const ToastContainer = ({ children, position = 'top-left', }) => {
    let Position = TopLeft;
    switch (position) {
        case 'top-left':
            Position = TopLeft;
            break;
        case 'bottom-center':
            Position = BottomCenter;
            break;
        case 'center-center':
            Position = CenterCenter;
    }
    return React.createElement(Position, null, children);
};

const Container = styled.div `
  box-shadow: 5px 5px 20px 1px rgba(0, 0, 0, 0.12);
  padding: 1rem 1.5rem;
  border-radius: 3px;
  font-size: 0.8rem;
  display: flex;
  align-items: flex-start;
  background-color: white;
  width: 19rem;
  color: #434657;
`;
const Icon$1 = styled.div(({ status }) => `
    border-radius: 50%;
    width: 1.125rem;
    height: 1.125rem;
    background-color: white;
    position: relative;
    margin-right: 1rem;
    background-color: ${status === 'success' ? '#30CD60' : 'transparent'};
    flex-shrink: 0;

    &::after {
      width: 5px;
      height: 8px;
      border: 2px solid white;
      content: ' ';
      transform: rotate(45deg) translate(-50%, -50%);
      transform-origin: top left;
      position: absolute;
      top: 45%;
      left: 50%;
      border-top: 0;
      border-left: 0;
    }
  `);
const Header = styled.p `
  margin: 0;
  margin-bottom: 0.5rem;
  font-size: 0.9375rem;
  line-height: 1.5rem;
  font-weight: 700;
`;
const Message$1 = styled.p `
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.125rem;
`;
const Center = styled.div ``;
const StatusToast = ({ header, message, }) => {
    return (React.createElement(Container, null,
        React.createElement(Icon$1, { status: "success" }),
        React.createElement(Center, null,
            React.createElement(Header, null, header),
            React.createElement(Message$1, null, message))));
};

const StyledToast$1 = styled.div `
  font-size: 12px;
  transition: 0.1s ease-out;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 6px 16px;
  height: auto;
  background-color: rgba(36, 36, 36, 0.9);
  color: white;
  outline: 0;
  border-radius: 20px;
  white-space: nowrap;
`;
const StyledWrapper = styled.div `
  background-color: #30cd60;
  box-shadow: 5px 5px 20px 1px rgba(0, 0, 0, 0.1);
  padding: 0.3rem 0.7rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: max-content;
`;
const Message = styled.p `
  color: white;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 0;
`;
const Icon = styled.div `
  border-radius: 50%;
  width: 1.125rem;
  height: 1.125rem;
  background-color: white;
  position: relative;
  margin-right: 0.3rem;

  &::after {
    width: 5px;
    height: 8px;
    border: 2px solid #30cd60;
    content: ' ';
    transform: rotate(45deg) translate(-50%, -50%);
    transform-origin: top left;
    position: absolute;
    top: 50%;
    left: 50%;
    border-top: 0;
    border-left: 0;
  }
`;
const InfoToast = ({ message, variant = 'info', }) => {
    return variant === 'success' ? (React.createElement(StyledWrapper, null,
        React.createElement(Icon, null),
        React.createElement(Message, null, message))) : (React.createElement(StyledToast$1, null, message));
};

const getToastBackground = (props) => {
    switch (props.type) {
        case 'error':
            return '#f8d7da';
        default:
            return 'rgba(65, 72, 93, 0.85)';
    }
};
const getToastColor = (props) => {
    switch (props.type) {
        case 'error':
            return 'rgb(97, 26, 21)';
        default:
            return '#fff';
    }
};
const getBorder = (props) => {
    switch (props.type) {
        case 'error':
            return '1px solid #f5c6cb';
        default:
            return 'none';
    }
};
const StyledToast = styled$1.div((props) => `
  bottom: 12px;
  left: 12px;
  background-color: ${getToastBackground(props)};
  color: ${getToastColor(props)};
  border: ${getBorder(props)};
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem 4rem;
  border-radius: 4px;
  font-size: 1.125rem;
  width: max-content;
`);
const StyledIcon = styled$1(SvgIcon) `
  margin-bottom: 1rem;
`;
const PopupToast = ({ message, icon, type = 'normal', }) => {
    return (React.createElement(StyledToast, { type: type },
        icon && React.createElement(StyledIcon, Object.assign({}, icon)),
        React.createElement("span", null, message)));
};

export { InfoToast as I, PopupToast as P, StatusToast as S, ToastMessage as T, ToastContainer as a };
